<div svcTestId="action-plan-reschedule__modal--content" class="flex flex-col bg-white">
  <div class="flex items-center justify-between border-b border-border py-4 pl-[18.4px] pr-[22px]">
    <div class="flex items-center gap-[5.5px]">
      <span
        class="reschedule-clock-icon"
        aria-hidden="true"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="8"
            cy="8"
            r="8"
            fill="#4D4D4D"
          />
          <path
            d="M8 4.5V8L10.5 9.5"
            stroke="white"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>

      <h2 class="m-0 font-sans text-xl font-semibold leading-7 text-[#4D4D4D]">{{ 'Reprogramar' | transloco }}</h2>
    </div>

    <button
      svcTestId="action-plan-reschedule__btn--close-header"
      mat-icon-button
      type="button"
      class="close-button flex h-[12px] w-[12px] min-h-[12px] min-w-[12px] items-center justify-center p-0"
      id="action-plan-reschedule-close-button"
      (click)="onClose()"
    >
      <mat-icon
        class="h-[12px] w-[12px] text-[12px] text-default"
        svgIcon="heroicons_outline:x-mark"
      ></mat-icon>
    </button>
  </div>

  <div class="px-2 pt-2">
    <form
      svcTestId="action-plan-reschedule__section--form"
      [formGroup]="form"
      class="reschedule-form flex flex-col gap-2"
    >
      <svc-date-picker
        svcTestId="action-plan-reschedule__input--due-date"
        class="w-full"
        inputId="action-plan-reschedule-due-date"
        formControlName="dueDate"
        [label]="'Data prevista' | transloco"
        [min]="minDate"
      ></svc-date-picker>
      <svc-audio-to-text-wrapper
        class="w-full"
        customClass="items-end reschedule-comment-wrapper"
        [control]="form.controls.comment"
        [shadow]="false"
        [showVoiceToTextButton]="showVoiceToTextButton"
      >
        <svc-text
          svcTestId="action-plan-reschedule__input--comment"
          inputId="action-plan-reschedule-comment"
          class="w-full"
          formControlName="comment"
          [maxLength]="200"
          [label]="'Comentário' | transloco"
          [placeholder]="'Opcional' | transloco"
        ></svc-text>
      </svc-audio-to-text-wrapper>
    </form>
  </div>

  <div class="border-t border-border px-2 pb-4 pt-2">
    <div class="flex justify-end gap-2">
      <svc-button-neutral
        svcTestId="action-plan-reschedule__btn--close"
        id="action-plan-reschedule-close"
        [label]="'Fechar' | transloco"
        type="button"
        (click)="onClose()"
      ></svc-button-neutral>

      <!-- Mirrors the escalate modal's confirm button so the disabled
           state tints with the client primary palette instead of the
           neutral grey that `<svc-button-confirm>` shipped for disabled. -->
      <svc-button
        svcTestId="action-plan-reschedule__btn--change"
        id="action-plan-reschedule-change"
        type="button"
        color="primary"
        mode="flat"
        [disabled]="isChangeDisabled"
        (click)="onChange()"
      >
        {{ 'Alterar' | transloco }}
      </svc-button>
    </div>
  </div>
</div>

